module.exports = __webpack_public_path__ + "img/250460827_2025_2-5.f77a3f87.png";